import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#7a6ad8',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

export default theme;